/* eslint-disable no-shadow */

// Valores padrão NFS-e Nacional. Confirmar com a equipe de backend.
export enum ServiceProvisionModeEnum {
  PRESENCIAL = 0,
  NAO_PRESENCIAL_INTERNET = 1,
  NAO_PRESENCIAL_OUTROS = 2,
  SEMI_PRESENCIAL_DOMICILIO_TOMADOR = 3,
  SEMI_PRESENCIAL_DOMICILIO_PRESTADOR = 4,
}

export const ServiceProvisionModeLabels: Record<number, string> = {
  [ServiceProvisionModeEnum.PRESENCIAL]: "Presencial",
  [ServiceProvisionModeEnum.NAO_PRESENCIAL_INTERNET]:
    "Não presencial - Internet",
  [ServiceProvisionModeEnum.NAO_PRESENCIAL_OUTROS]:
    "Não presencial - Outros meios",
  [ServiceProvisionModeEnum.SEMI_PRESENCIAL_DOMICILIO_TOMADOR]:
    "Semipresencial - Domicílio do Tomador",
  [ServiceProvisionModeEnum.SEMI_PRESENCIAL_DOMICILIO_PRESTADOR]:
    "Semipresencial - Domicílio do Prestador",
};

export const ServiceProvisionModeList = Object.keys(ServiceProvisionModeLabels)
  .map(Number)
  .map((value) => ({ value, label: ServiceProvisionModeLabels[value] }));
